import React from 'react';
import { Button } from 'components';
import axios from 'axios';
import { getCookie } from 'common/Cookie';
import { ScheduleGridData } from 'pages/ScheduleContact/types';
import { useNavigate } from 'react-router-dom';
import styles from './Payment.module.css'; 

interface AccountTransferModalProps {
  isOpen: boolean;
  onClose: () => void;
  // onConfirm prop은 현재 내부 handleConfirm에 의해 사용되지 않으므로, 필요 없다면 제거해도 됩니다.
  onConfirm: (data: ScheduleGridData[]) => void;
  amount: { currency: string; value: number };
  orderId: string | null;
  country: string | null; 
  data: ScheduleGridData[];
}

const AccountTransferModal = ({ isOpen, amount, country, orderId ,onClose, onConfirm, data }: AccountTransferModalProps) => {
  const navigate = useNavigate();
  
  if (!isOpen) return null;
  
  const handleConfirm = async () => {
    const token = getCookie('accessToken');
    
    try {
      const response = await axios.post("/api/confirm/save",{
        amount: amount.value,
        currency: country=== 'KR' ? "KRW" : "USD",
        scheduleId: 1, // 이 부분은 동적으로 변경해야 할 수 있습니다.
        orderId,
        method: "BANK_TRANSFER",
        data: data,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      
      console.log(response.data);
      
      onClose(); // 성공 시 모달 닫기
      navigate('/manage-contacts'); // 페이지 이동
    } catch (error) {
      console.error("Error confirming the transfer", error);
      alert("An error occurred during confirmation."); // 사용자에게 오류 알림
    }
  };

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <h1 className={styles.modalTitle}>Account Transfer Information</h1>
        <p className={styles.modalDescription}>Please deposit the total amount to the account below.</p>
        
        {/* 국내/해외 계좌 정보 표시 */}
        <div className={styles.accountInfoBox}>
            <p><strong>Bank Name:</strong> <span>IOPS</span></p>
            <p><strong>Account Number:</strong> <span>추가 예정</span></p>
            <p><strong>Total Amount:</strong> <span>{amount.value.toLocaleString()} {amount.currency}</span></p>
        </div>

        <div className={styles.modalButtons}>
          <Button text="Cancel" onClick={onClose} type="secondary" />
          <Button text="Confirm Reservation" onClick={handleConfirm} type="primary" />
        </div>
      </div>
    </div>
  );
};

export default AccountTransferModal;